/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Err_Not_Found_TitleInputs */

const en_err_not_found_title = /** @type {(inputs: Err_Not_Found_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Page not found`)
};

const id_err_not_found_title = /** @type {(inputs: Err_Not_Found_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Halaman tidak ditemukan`)
};

/**
* | output |
* | --- |
* | "Page not found" |
*
* @param {Err_Not_Found_TitleInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const err_not_found_title = /** @type {((inputs?: Err_Not_Found_TitleInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Err_Not_Found_TitleInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_err_not_found_title(inputs)
	return en_err_not_found_title(inputs)
});